"use strict"

import React, { useEffect, useRef, useState } from "react"
import { Modal, Button } from "react-bootstrap"
import PropTypes from "prop-types"
import { FormattedMessage } from "react-intl"

import { API_STATUS } from "../../../../shared_components/widgets/utils"
import UploadData from "../../../widgets/UploadData"
import PageLoadingPanel from "../../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../../shared_components/widgets/PageErrorPanel"

export default function ModalUploadDataFile(props) {
  const ref_upload = useRef()
  const ref_loader = useRef()
  const [status_init, setStatusInit] = useState(API_STATUS.LOADING)
  const [data, setData] = useState(null)

  useEffect(() => {
    onInitialLoad()
  }, [])

  const onInitialLoad = () => {
    let data = Object.assign({}, props.sample)
    data["has_sampling_time"] = data.sampling_time != null
    setStatusInit(API_STATUS.SUCCESS)
    setData(data)
  }

  const showRef = (r) => (r.current ? (r.current["style"].display = `block`) : null)
  const hideRef = (r) => (r.current ? (r.current["style"].display = `none`) : null)

  return (
    <Modal show={props.show} onHide={props.onHide} backdrop={"static"} keyboard={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={"fa fa-arrow-circle-o-up"} />
          &nbsp;&nbsp;
          <FormattedMessage id={"samplemanagement.modal.title.upload_data_for_sample"} />{" "}
          {data ? '"' + data.sample_id + '"' : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ width: "600px" }}>
          {status_init === API_STATUS.LOADING && <PageLoadingPanel />}
          {status_init === API_STATUS.ERROR && <PageErrorPanel attemptReload={onInitialLoad} />}
          {status_init === API_STATUS.SUCCESS ? (
            !data.has_sampling_time ? (
              <div className={"text-danger"} align={"center"} style={{ padding: "30px 0px" }}>
                <span className={"fa fa-exclamation-circle text-danger"} style={{ fontSize: "60px" }} />
                <br />
                <FormattedMessage
                  id={"samplemanagement.complete.round.proir.to.upload.message"}
                  description={"Complete Round Prior To Uploading Data Message"}
                />
                <div className={"text_black"} style={{ marginTop: "15px" }}>
                  <FormattedMessage
                    id={"samplemanagement.complete.round.instruction"}
                    description={"Click Complete Round Button Instruction"}
                  />{" "}
                  - #{data.sample_round}
                </div>
              </div>
            ) : (
              <>
                <p>
                  <FormattedMessage
                    id={"samplemanagement.follow.instructions.message"}
                    description={"Follow Upload Instructions Message"}
                  />
                </p>
                <ul>
                  <li className={"text-success"} style={{ marginBottom: "10px" }}>
                    <strong>
                      <FormattedMessage id={"general.step"} description={"Step Label"} /> 1:
                    </strong>
                    &nbsp;
                    <FormattedMessage
                      id={"samplemanagement.complete.the.sample.round"}
                      description={"Complete the Sample Round Instruction"}
                    />
                    :&nbsp;
                    <span className={"text-success"} style={{ marginLeft: "10px" }}>
                      -&nbsp;
                      <span className={"fa fa-check text-success"} />
                      &nbsp;
                      <FormattedMessage id={"general.done"} description={"Done Message"} />
                    </span>
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    <strong>
                      <FormattedMessage id={"general.step"} description={"Step Label"} /> 2:
                    </strong>
                    &nbsp;
                    <FormattedMessage
                      id={"general.download.template"}
                      description={"Download Template Instruction"}
                    />{" "}
                    :
                    <div align={"center"} style={{ marginTop: "10px" }}>
                      <a
                        className={"link_btn_outline_primary btn btn-sm"}
                        href={
                          "/laboratory/sample-management/sample/" +
                          props.sample.id +
                          "/download_sample_data_template/"
                        }
                        style={{ marginLeft: "10px" }}
                        target={"_blank"}
                      >
                        <span className={"fa fa-floppy-o text-success"} />
                        &nbsp;
                        <FormattedMessage
                          id={"samplemanagement.download.sample.template"}
                          description={"Download Sample Template"}
                        />
                      </a>
                    </div>
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    <strong>
                      <FormattedMessage id={"general.step"} description={"Step Label"} /> 3:
                    </strong>
                    &nbsp;
                    <FormattedMessage
                      id={"samplemanagement.open.template.enter.data"}
                      description={"Open, Fill In, and Save Instruction"}
                    />
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    <strong>
                      <FormattedMessage id={"general.step"} description={"Step Label"} /> 4:
                    </strong>
                    &nbsp;
                    <FormattedMessage
                      id={"samplemanagement.click.upload.and.select.file"}
                      description={"Click Upload Button and Select File Instruction"}
                    />
                    <div ref={ref_upload}>
                      <UploadData
                        file_type={"Sample Data Uploader"}
                        process_now={true}
                        params={{
                          sample_id: props.sample.id,
                        }}
                        submit_file={() => {
                          hideRef(ref_upload)
                          showRef(ref_loader)
                        }}
                        refresh_data={() => {
                          props.onSuccess()
                          showRef(ref_upload)
                          hideRef(ref_loader)
                        }}
                        on_upload_fail={() => {
                          showRef(ref_upload)
                          hideRef(ref_loader)
                        }}
                      />
                    </div>
                    <div ref={ref_loader} align={"center"} style={{ display: "none", marginTop: "10px" }}>
                      <div className={"spinner-border text-primary text-center"} role={"status"} />
                      &nbsp;&nbsp;
                      <h5>
                        <FormattedMessage
                          id={"general.uploading.file"}
                          description={"Uploading File Message"}
                        />
                        ...
                      </h5>
                    </div>
                  </li>
                </ul>
              </>
            )
          ) : (
            <></>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant={"outline-primary"} onClick={props.onHide}>
          <FormattedMessage id={"general.closeButton"} description={`Close Modal Button`} />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ModalUploadDataFile.propTypes = {
  sample: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
